const betaURL = require("app/util/config/beta-url");
const CardWithLoader = require("../Dashboard/card-with-loader");
const Summary = require("../Dashboard/summary");

const Reflux = require("reflux");
const DealLossReasonsStore = require("../../stores/deal-loss-reasons-store");
const DealLossReasonsActions = require("../../actions/deal-loss-reasons-actions");

const Chart = require("../Dashboard/Chart/chart");

const currencyFormatter = require("app/util/formatter/currency");
const moment = require("moment");

const DealLossReasonsWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState: function() {
    return DealLossReasonsStore.getInitialState();
  },

  componentDidMount: function() {
    this.listenTo(DealLossReasonsStore, this.setState);
    this.refresh();
  },

  componentDidUpdate: function(prevProps) {
    if (prevProps != this.props) {
      this.refresh();
    }
  },

  refresh: function() {
    DealLossReasonsActions.fetchData(
      this.props.period,
      this.props.users,
      this.props.funnel
    );
  },

  getItemFromElement: function(element) {
    return element && this.state.data.lossReasons[element._index];
  },

  isInteractiveItem: function(item) {
    return item && !item.rest;
  },

  getDetailsUrl: function(id) {
    let dateFormat = "YYYY-MM-DD";
    let formattedStartDate = this.props.period.startDate.format(dateFormat);
    let formattedEndDate = this.props.period.endDate.format(dateFormat);

    let searchParams = new URLSearchParams();

    searchParams.append("sn", 3);
    searchParams.append("dci", formattedStartDate);
    searchParams.append("dcf", formattedEndDate);
    searchParams.append("qpp", 25);
    searchParams.append("mp", id || -1);

    if (this.props.selectedUser)
      searchParams.append("ur", this.props.selectedUser);
    if (this.props.selectedTeam)
      searchParams.append("team", this.props.selectedTeam);
    if (this.props.funnel)
      searchParams.append("funil", this.props.funnel);

    return `${betaURL()}/deals?${searchParams}`;
  },

  render: function() {
    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <p>Principais motivos de perda</p>
        }
        className="grid-item-col-2"
        footer={
          <span className="text-muted">
            Clique em um segmento para ver a lista de negócios
          </span>
        }
      >
        <div className="d-g grid-2 gg-20">
          <div className="grid-item-col-2">
            <Chart
              type="pie"
              colorSet="B"
              datasets={[
                {
                  data: this.state.data.lossReasons.map(item => item.total_amount)
                }
              ]}
              labels={this.state.data.lossReasons.map(item => (
                item.name || "Não especificado"
              ))}
              options={{
                tooltips: {
                  callbacks: {
                    title: (tooltipItem, data) => data.labels[tooltipItem[0].index],
                    label: (tooltipItem, data) => {
                      const dataset = data.datasets[0];

                      const value = this.state.data.lossReasons[tooltipItem.index].total_amount;
                      const visibleTotal = dataset._meta[Object.keys(dataset._meta)[0]].total;
                      const percentage = visibleTotal === 0
                        ? "0%"
                        : ((value / visibleTotal) * 100).toFixed(1) + "%";

                      const formattedValue = currencyFormatter.formatCentsToCurrency(value);
                      const count = this.state.data.lossReasons[tooltipItem.index].count;

                      return ([
                        `${formattedValue} (${percentage})`,
                        `${count} negócios`
                      ]);
                    }
                  }
                },
                onHover: (event, [element]) => {
                  let item = this.getItemFromElement(element);

                  if (this.isInteractiveItem(item)) {
                    event.target.style.setProperty("cursor", "pointer");
                  } else {
                    event.target.style.removeProperty("cursor");
                  }
                },
                onClick: (_, [element]) => {
                  let item = this.getItemFromElement(element);

                  if (this.isInteractiveItem(item)) {
                    window.open(this.getDetailsUrl(item.id), "_blank");
                  }
                }
              }}
            />
          </div>
        </div>
      </CardWithLoader>
    )
  }
});

module.exports = DealLossReasonsWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/deal-loss-reasons.jsx